'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosAmericanfootballOutline = function IoIosAmericanfootballOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.4 10.4c8.7 8.7 6.3 25.5 6.3 25.5s-2 0.4-5.1 0.4c-5.7 0-14.8-1-20.5-6.7-8.7-8.7-6.3-25.5-6.3-25.5s2-0.4 5.1-0.4c5.7 0 14.8 1 20.5 6.7z m-24.6-5.3c-0.1 1.5-0.4 4.7 0 8.3 0.1 0.7 0.2 1.3 0.3 1.8l9.9-9.9c-2-0.2-4-0.4-6.1-0.4-1.7 0-3.2 0.1-4.1 0.2z m6.2 23.7c2.3 2.3 5.6 4.1 9.7 5.1 0.8 0.2 1.6 0.4 2.4 0.6l11.1-11.1c-0.3-1.8-0.8-3.5-1.3-5-1.1-2.9-2.5-5.3-4.4-7.2-2.3-2.3-5.6-4.1-9.7-5.1-0.8-0.2-1.5-0.4-2.4-0.6l-11.1 11.1c0.3 1.8 0.8 3.5 1.3 5 1.1 2.9 2.5 5.3 4.4 7.2z m23.7 6.1c0.1-1.5 0.4-4.7 0-8.3-0.1-0.7-0.2-1.3-0.3-1.8l-9.9 9.9c2 0.2 4 0.4 6.1 0.4 1.7 0 3.2-0.1 4.1-0.2z m-11-10.1l-2.2 2.3-0.9-0.9 2.3-2.2-1.8-1.8-2.2 2.3-1-1 2.3-2.2-1.8-1.8-2.2 2.3-0.9-0.9 2.3-2.2-1.8-1.8-2.2 2.2-1-0.9 2.3-2.2-1.7-1.8-2.3 2.3-0.8-1 5.2-5.2 0.9 0.9-2.2 2.2 1.8 1.8 2.1-2.3 1 0.9-2.3 2.2 1.8 1.8 2.2-2.3 0.9 1-2.2 2.2 1.8 1.8 2.2-2.3 0.9 0.9-2.3 2.2 1.8 1.8 2.2-2.2 1 0.9-2.3 2.2 1.7 1.8 2.3-2.3 0.8 1-5.2 5.2-0.9-0.9 2.2-2.2z' })
        )
    );
};

exports.default = IoIosAmericanfootballOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-americanfootball-outline.js
// module id = 2088
// module chunks = 0